import { FormControl } from '@angular/forms';
import { input, output, Component, ChangeDetectionStrategy } from '@angular/core';

import { ToggleGroup } from './types';

@Component({
  selector: 'app-button-toggle-group',
  standalone: true,
  templateUrl: './button-toggle-group.html',
  styleUrl: './button-toggle-group.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button-toggle-group',
  },
})
export class ButtonToggleGroup {
  public tabs = input.required<ToggleGroup[]>();

  public control = input.required<FormControl<string>>();

  public groupChangeEvent = output<string>();

  changeTab(tab: ToggleGroup) {
    this.control().setValue(tab.key);
    this.control().markAsDirty();
    this.control().markAsTouched();

    this.groupChangeEvent.emit(tab.key);
  }
}
